import React, { useEffect, useRef } from 'react';

import styled from 'styled-components';

import amplitude from 'amplitude-js';
import { sendBrazeEvent } from 'apps/auth/analytics/braze';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import InvitePopup from 'apps/auth/components/invite/InvitePopup';
import ShareOrDownloadQRCodeModal from 'apps/auth/components/invite/referralQRCode/ShareOrDownloadQRCodeModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { BONUS_INVITATION_CLICKED, SHARE_LINK_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    BR_BANNER_EXTRA_BONUS_CLOSED,
    BR_BANNER_EXTRA_BONUS_PRESSED_ARROW,
    BR_BANNER_EXTRA_BONUS_PRESSED_T_AND_C,
} from 'apps/auth/constants/braze/brazeEvents';
import { AUTH_PROFILE, AUTH_SEND_MAIN_LINK, RULES } from 'apps/auth/constants/UrlConstants';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { copyTextToClipboard, resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useAuth, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { getHeaderText, getSecondaryText } from 'apps/auth/services/bonusService';
import { showPromoModal } from 'apps/auth/services/promoModalService';
import Cookies from 'universal-cookie';

import MgmPromoStories from './MgmPromoStories';
import ShareInvitationLinkPopup from './ShareInvitationLinkPopup';

const StepsList = styled.ul`
    list-style-type: none;
    margin: 0 16px 0 32px;
    padding: 0;

    li {
        margin: 0;
        position: relative;
        padding: 0 0 0 16px;

        &::before {
            content: '•';
            font-size: 90%;
            left: 0;
            position: absolute;
            top: 0;
        }

        & + li {
            margin-top: 4px;
        }
    }
`;

const cookies = new Cookies();

export const InviteFriendsPage = (props) => {
    const { ballId, countryId, isShowModal } = useAuth();
    const { country } = useApp();
    const { lang } = useLanguage();
    const openExtraBonusModal = useRef();
    const popupRef = useRef(null);
    const popupFullwidthRef = useRef(null);
    const modalRef = useRef(null);
    const { bonusBanner, bonusBalance, bonusReferralInfo, mgmPromoSlider, showMgmPromoSlider, giveaway, profile } = useExtra();
    const {
        learnMore,
        gotIt,
        bonusShare,
        bonusHowItWorks,
        bonusAboutRulesTitle,
        bonusInfoTitle2,
        detailsCopy,
        bonusInfoCopyTitle,
        copied,
        bonusInviteAnd,
        bonusForInvite,
        bonusCodeAndLink,
        friendsJoined,
        friendsJoinedSubtitle,
        transfersSent,
        transfersSentSubtitle,
        totalEarnedSubtitle,
        bonusAboutBlock1TextUsa1,
        bonusAboutBlock1TextUsa2,
        bonusAboutBlock1TextUsa3,
        bonusAboutBlock2TextUsa1,
        bonusAboutBlock2TextUsa2,
        bonusAboutBlock2TextUsa3,
        bonusAboutBlock2TextUsa4,
        bonusAboutBlock2TextUsa5,
        bonusAboutBlock4Text,
        bonusAboutBlock1Text,
        bonusAboutBlock2Text,
        bonusAboutBlock3Text,
        shareLinkText,
        shareInvitationLinkButton,
        trackReferralsButton,
    } = usePageMessages();

    const closeMgmPromoStories = () => {
        popupRef.current?.open(
            <ShareInvitationLinkPopup
                popupRef={popupRef}
                text={shareLinkText}
                shareInvitationLinkButton={shareInvitationLinkButton}
                trackReferralsButton={trackReferralsButton}
            />,
        );
    };

    const notNowButtonClick = () => {
        props.toggleSpinner(true);
        window.location.href = AUTH_SEND_MAIN_LINK;
    };

    useEffect(() => {
        const showModal = showPromoModal(ballId, mgmPromoSlider, 'mgm_info');
        if (showModal) {
            popupFullwidthRef.current?.open(
                <MgmPromoStories
                    sliders={mgmPromoSlider}
                    onTopButtonClick={notNowButtonClick}
                    modalRef={modalRef}
                    onBottomButtonClick={closeMgmPromoStories}
                />,
            );
        }
    }, [showMgmPromoSlider]);

    useEffect(() => {
        const banner = Array.isArray(bonusBanner) ? bonusBanner.find((b) => b?.country_id === countryId) : bonusBanner;
        const cookieName = 'promo_strapi_banner_' + banner?.unique_banner_id;
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        const expirationDate = new Date(banner?.expiration_date);
        if (banner?.country_id === countryId && now.getTime() < expirationDate?.getTime() && cookies.get(cookieName) === undefined) {
            const bannerUrl = banner?.icon?.data?.attributes?.url;
            props
                .toggleModal(
                    true,
                    <ModalComponent canCloseModal={false}>
                        <InfoPage
                            insideModalComponent
                            iconName={bannerUrl ? undefined : 'gift-80'}
                            iconColor={'primary'}
                            iconSrc={`${bannerUrl}`}
                            headerText={getHeaderText(banner)}
                            secondaryText={getSecondaryText(banner)}
                            buttonRowCaption={learnMore}
                            buttonRowType={'link'}
                            buttonRowTarget="_blank"
                            buttonRowHref={banner.term_url}
                            buttonRowOnClick={() => {
                                sendBrazeEvent(BR_BANNER_EXTRA_BONUS_PRESSED_T_AND_C);
                            }}
                            primaryButtonCaption={gotIt}
                            primaryButtonType={'link'}
                            primaryButtonOnClick={() => {
                                openExtraBonusModal.current = false;
                                cookies.set(cookieName, true, { path: '/', expires: expirationDate });
                                sendBrazeEvent(BR_BANNER_EXTRA_BONUS_CLOSED);
                                props.toggleModal(false);
                            }}
                        />
                    </ModalComponent>,
                    true,
                    false,
                )
                .then(() => {
                    openExtraBonusModal.current = true;
                });
        }
    }, [bonusBanner]);

    useEffect(() => {
        if (!isShowModal && openExtraBonusModal.current) {
            sendBrazeEvent(BR_BANNER_EXTRA_BONUS_PRESSED_ARROW);
        }
    }, [isShowModal]);

    const referralInfo = bonusReferralInfo?.referralInfo;
    const isUsaUser = countryId === USA;
    const steps = [bonusAboutBlock2TextUsa2, bonusAboutBlock2TextUsa3, bonusAboutBlock2TextUsa4];
    const referralInfoBlocks = [
        {
            icon: 'people',
            value: referralInfo?.friends,
            text: friendsJoined,
            subtext: friendsJoinedSubtitle,
        },
        {
            icon: 'navigation-arrow',
            value: referralInfo?.transfers,
            text: transfersSent,
            subtext: transfersSentSubtitle,
        },
        {
            icon: 'coins',
            value: referralInfo?.amount?.value,
            text: referralInfo?.amount?.ccyIso,
            subtext: totalEarnedSubtitle,
        },
    ];

    const renderRules = () => {
        if (countryId === USA) {
            return <Button type="link" variant="row" href={`/en-us${RULES}`} caption={bonusAboutRulesTitle} negativeMargin />;
        }

        return <Button type="link" variant="row" href={bonusBalance?.bonusOffer} target="_blank" caption={bonusAboutRulesTitle} negativeMargin />;
    };

    const getMaxPossibleAmount = (referralInfo = {}) => {
        let amount = Number(referralInfo?.bonus?.value) * Number(referralInfo?.bonus?.count);
        return getLocalizedRawAmount(lang, country, amount);
    };

    return (
        <>
            <CommonPage
                backUrl={AUTH_PROFILE}
                hasBottomPanel
                showChat={false}
                rightHeaderComponent={
                    <DiskButton
                        type="button"
                        iconName="qr-code"
                        onClick={() => {
                            modalRef.current?.open(
                                <ShareOrDownloadQRCodeModal modalRef={modalRef} referralLink={bonusBalance?.sharedLink} userName={profile?.userName} />,
                            );
                        }}
                    />
                }
            >
                <Row indent="adaptive-16-24">
                    <DiskBadge iconName="people-48" diskSize="large" variant="secondary" />
                </Row>

                <Row indent="48px">
                    <Text color="primary" size="header">
                        {bonusInviteAnd}
                    </Text>
                    <br />
                    <Text size="header">{resolveArguments(bonusForInvite, [getMaxPossibleAmount(referralInfo), referralInfo?.bonus?.ccyIso])}</Text>
                </Row>

                {referralInfo && (
                    <Row indent="48px">
                        {referralInfoBlocks.map((block, index) => {
                            return (
                                <Panel negativeMargin key={`block_${index}`} isDefaultCursor>
                                    <PanelFrame>
                                        <DiskBadgeWrapper>
                                            <DiskBadge variant="tertiary" iconName={block.icon} />
                                        </DiskBadgeWrapper>
                                        <PanelContent>
                                            <Text variant="div" color="primary">{`${block.value} ${block.text}`}</Text>
                                            <Text variant="div" color="secondary" size="secondary">
                                                {block.subtext}
                                            </Text>
                                        </PanelContent>
                                    </PanelFrame>
                                </Panel>
                            );
                        })}
                    </Row>
                )}

                <Separator marginTop="0" marginBottom="48px" marginTopDesktop="0" />

                <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                    {bonusCodeAndLink}
                </Text>

                <Row indent="adaptive-32-48">
                    <DetailsItem
                        dataTestId="invite-friends-page-button-copied"
                        detailsTitle={bonusInfoCopyTitle}
                        detailsText={`paysend.com/${lang}/referral/${bonusBalance?.inviteCode}`}
                        detailsButton={detailsCopy}
                        detailsButtonClick={(e) => {
                            e.preventDefault();
                            const result = copyTextToClipboard(`paysend.com/${lang}/referral/${bonusBalance?.inviteCode}`);
                            if (result) {
                                props.toggleSnackBar(true, `${bonusInfoCopyTitle} ${copied}`);
                            }
                        }}
                    />
                </Row>

                <Separator marginTop="32px" marginBottom="48px" />

                {giveaway && (
                    <>
                        <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                            {giveaway.header}
                        </Text>
                        <Row>
                            <Text variant="div" indent="adaptive-16-24">
                                {giveaway.text}
                            </Text>
                            {giveaway.link_label && giveaway.link && (
                                <Button type="link" variant="row" href={giveaway.link} caption={giveaway.link_label} negativeMargin />
                            )}
                        </Row>
                    </>
                )}

                <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                    {bonusHowItWorks}
                </Text>
                {isUsaUser ? (
                    <>
                        <Row indent="32px">
                            <Text variant="div" indent="adaptive-16-24">
                                {`${bonusAboutBlock1TextUsa1}*`}
                            </Text>
                            <Text variant="div" indent="adaptive-16-24">
                                {bonusAboutBlock1TextUsa2}
                            </Text>
                            <Text variant="div" indent="adaptive-16-24">
                                {bonusAboutBlock1TextUsa3}
                            </Text>
                        </Row>
                    </>
                ) : (
                    <DocsList>
                        <DocsListItem blackText>
                            <div dangerouslySetInnerHTML={{ __html: bonusAboutBlock1Text }} />
                        </DocsListItem>
                        <DocsListItem blackText>
                            <div dangerouslySetInnerHTML={{ __html: bonusAboutBlock2Text }} />
                        </DocsListItem>
                        <DocsListItem blackText>
                            <div dangerouslySetInnerHTML={{ __html: bonusAboutBlock3Text }} />
                        </DocsListItem>
                    </DocsList>
                )}

                <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                    {bonusInfoTitle2}
                </Text>
                {isUsaUser ? (
                    <>
                        <Row indent="32px">
                            <Text variant="div" indent="adaptive-16-24">
                                {bonusAboutBlock2TextUsa1}
                            </Text>
                            <StepsList>
                                {steps.map((value, index) => (
                                    <li key={`${index}stepsDesc`}>{value}</li>
                                ))}
                            </StepsList>
                        </Row>
                        <Row>
                            <Text variant="paragraph" indent="32px">
                                {bonusAboutBlock2TextUsa5}
                            </Text>
                        </Row>
                    </>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: bonusAboutBlock4Text }} />
                )}
                {renderRules()}

                <FixedBottomPanel isRightAligned>
                    <Button
                        type="button"
                        raised={true}
                        onClick={() => {
                            amplitude.getInstance().logEvent(SHARE_LINK_CLICKED);
                            amplitude.getInstance().logEvent(BONUS_INVITATION_CLICKED);
                            popupRef.current?.open(<InvitePopup popupRef={popupRef} />);
                        }}
                        caption={bonusShare}
                        title={bonusShare}
                    />
                </FixedBottomPanel>
            </CommonPage>
            <PopupNew ref={popupRef} />
            <PopupNew ref={popupFullwidthRef} fullwidthPopup />
            <ModalNew ref={modalRef} />
        </>
    );
};

export default BasePage(InviteFriendsPage);
